'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.home', {
    url: 'home',
    template: '<home></home>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/home/home.routes.js